import './PopupWebinar.scss';
import { SharePage } from '../../../SharePage/SharePage';
import { AiOutlineClose } from 'react-icons/ai';

export const PopupWebinar = ({ closePopupHandler, ...props }) => {
    return <div className="c-detail-fiche--webinar">
        <div className="c-detail-fiche--webinar__header">
            <div className="popupClosingIconContainer" onClick={() => closePopupHandler()}>
                <AiOutlineClose className="popupClosingIcon" />
            </div>
            {
                props.data?.detailBody?.video &&
                <div dangerouslySetInnerHTML={{ __html: props.data?.detailBody?.video.preview }}></div>                   
            }
        </div>
        <div className="c-detail-fiche--webinar__body">
            <div className="c-detail-fiche--webinar__body__title">
                <h2>{props.data.title}</h2>
            </div>
            <div className="c-detail-fiche--webinar__body__info">
                {
                    props.data?.detailSideBar && <ul>
                        {/* Autor, publication date, Source */}
                        {
                            props.data.detailSideBar?.author && <li>
                                <span className="c-detail-fiche--webinar__body__info__label">Auteur</span>
                                <span className="c-detail-fiche--webinar__body__info__value">{props.data.detailSideBar.author}</span>
                            </li>
                        }
                        {
                            props.data.detailSideBar?.publicationDate && <li>
                                <span className="c-detail-fiche--webinar__body__info__label">Publicatiedatum</span>
                                <span className="c-detail-fiche--webinar__body__info__value">{props.data.detailSideBar.publicationDate}</span>
                            </li>
                        }
                        {
                            props.data.detailSideBar.source && (props.data.detailSideBar?.sourceUrl?.url ? <li>
                                <span className="c-detail-fiche--webinar__body__info__label">Bron</span>
                                <span className="c-detail-fiche--webinar__body__info__value">
                                    <a href={props.data.detailSideBar?.sourceUrl?.url} target={props.data.detailSideBar?.sourceUrl?.target} className="c-detail-fiche--webinar__body__info__link">
                                        {props.data.detailSideBar.source}
                                    </a>
                                </span>
                            </li>
                                : <li>
                                    <span className="c-detail-fiche--webinar__body__info__label">Bron</span>
                                    <span className="c-detail-fiche--webinar__body__info__value">{props.data.detailSideBar.source}</span>
                                </li>)
                        }
                    </ul>
                }
            </div>
            <div className="c-detail-fiche--webinar__body__description">
                <div dangerouslySetInnerHTML={{ __html: props.data.detailBody.content }}></div>
            </div>
            <div className="c-detail-fiche--webinar__body__share">
                <div className="row">
                    <div className="col-md-6 col-12">
                        <div className="download">
                            {
                                props.data.detailBody?.button?.title &&
                                <a href={props.data.detailBody.button?.url} className="c-button c-button--block" target={props.data.detailBody.button.target}>
                                    {props.data.detailBody.button?.title} <i class="fa-regular fa-download"></i>
                                </a>
                            }
                        </div>
                    </div>
                    <div className="col-md-6 col-12">
                        <span className='c-detail-fiche--webinar__body__share__social'>
                            <SharePage shareTitle={props.data.title} />
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>;
}



